import { MANUAL_DOWNLOAD } from '01_core/constants/APIs';
import { INFOBAR_VARIANT } from '01_core/reducers/coreInfoBarActions';
import { LABEL } from '01_core/constants/labelConsts';

/**
 * メニューのドキュメントリンク（アクションコード2）の時の処理。
 */
export const documentLinkActions = {
  documentlink_safety_criteria: (callAPIRawResponse, documentLink, openInfoBar, intl) => () => {
    const { safetyCriteriaUrl } = documentLink;
    const fileNm = safetyCriteriaUrl;
    const sendData = {
      fileNm: fileNm,
    };
    callAPIRawResponse(MANUAL_DOWNLOAD, sendData)
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size > 0) {
          let anchor = document.createElement('a');
          anchor.download = fileNm;
          anchor.href = window.URL.createObjectURL(blob);
          anchor.click();
        } else {
          openInfoBar(INFOBAR_VARIANT.ERROR, intl.formatMessage({ id: LABEL.CORE_FILE_NOT_FOUND_MESSAGE }));
        }
      });
  },
};